import SideMenu from "components/organisms/SideMenu";

const Header = () => {
    return (
        <header>
            <div className="h-menu">
                <input
                    id="h-menu_checkbox"
                    className="h-menuCheckbox"
                    type="checkbox"
                />
                <label className="h-menu_icon" htmlFor="h-menu_checkbox">
                    <span className="hamburger-icon"></span>
                </label>
                <label
                    id="h-menu_black"
                    className="h-menuCheckbox"
                    htmlFor="h-menu_checkbox"
                ></label>
                <div id="h-menu_content">
                    <SideMenu />
                </div>
            </div>
        </header>
    );
};

export default Header;
